var map = {
	"./BTCL - Playing Conditions v13 - 2023 - English.pdf": 1832,
	"./adidas-logo.png": 4275,
	"./btcl-100-club.png": 7533,
	"./calendar-icon.png": 8711,
	"./champion.png": 9102,
	"./contact-location.png": 79,
	"./contact-mail.png": 2623,
	"./contact-phone.png": 6976,
	"./division_hero_bg.png": 2381,
	"./facebook-icon.png": 7645,
	"./facebook.png": 7359,
	"./featured.png": 2977,
	"./flight.png": 1193,
	"./footer-logo.jpg": 8872,
	"./greenflight.png": 8568,
	"./greenhome.png": 747,
	"./hero.jpg": 4323,
	"./home.png": 6574,
	"./instagram-icon.png": 1589,
	"./instagram.png": 9719,
	"./location-icon.png": 2114,
	"./location.png": 1198,
	"./logo-b.png": 1015,
	"./logo-c.png": 2174,
	"./logo.png": 678,
	"./mail-icon.png": 8570,
	"./map.png": 9625,
	"./mobile-icon.png": 2891,
	"./news.png": 3726,
	"./news_banner_bg.png": 9799,
	"./noresult.png": 361,
	"./not01.jpg": 4113,
	"./not02.jpg": 3766,
	"./not03.jpg": 227,
	"./partner/Samsung.png": 4212,
	"./partner/partner.png": 8482,
	"./player-profile.png": 9948,
	"./player.png": 8876,
	"./share-icon-2.png": 4335,
	"./share-icon.png": 7022,
	"./side1.png": 9033,
	"./side2.png": 8066,
	"./team-logo-big.png": 7455,
	"./team-logo.png": 1578,
	"./team-logo2.png": 4834,
	"./team.png": 88,
	"./teamProfileBg.png": 5356,
	"./teamProfileImg.png": 8528,
	"./teamcover 2.png": 4629,
	"./teamcover.png": 5575,
	"./twitter-icon.png": 42,
	"./twitter.png": 4678,
	"./youtube-icon.png": 8380,
	"./youtube.png": 4632
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;